import React from 'react';

const LGPDComplianceContent = () => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Conformidade com a LGPD – Justiçai</h2>
      
      <p className="text-sm text-muted-foreground">
        Última atualização: 02 de setembro de 2025
      </p>
      
      <p>
        A Octopus Group – CNPJ 34.997.786/0001-85 ("Octopus Group", "nós"), empresa responsável pela tecnologia Laib 
        e pela operação da plataforma Justiçai, declara seu compromisso com a Lei Geral de Proteção de Dados Pessoais 
        (Lei nº 13.709/2018 – LGPD), garantindo a proteção, privacidade e transparência no tratamento de dados pessoais.
      </p>
      
      <section>
        <h3 className="text-md font-medium mb-2">1. Compromisso com a Conformidade</h3>
        <p>
          O Justiçai adota políticas, procedimentos e medidas técnicas e administrativas para assegurar que o tratamento de 
          dados pessoais respeite os direitos fundamentais de liberdade, privacidade e o livre desenvolvimento da 
          personalidade do titular de dados.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">2. Bases Legais do Tratamento</h3>
        <p>
          O tratamento de dados pessoais é realizado com fundamento nas hipóteses legais da LGPD, incluindo:
        </p>
        <p className="mt-2">• Consentimento do titular (art. 7º, I);</p>
        <p className="mt-1">• Execução de contrato ou de procedimentos preliminares relacionados a contrato (art. 7º, V);</p>
        <p className="mt-1">• Cumprimento de obrigação legal ou regulatória (art. 7º, II);</p>
        <p className="mt-1">• Exercício regular de direitos em processo judicial, administrativo ou arbitral (art. 7º, VI);</p>
        <p className="mt-1">• Legítimo interesse da Octopus Group ou de terceiros (art. 7º, IX), sempre respeitando os direitos e liberdades fundamentais dos titulares.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">3. Direitos dos Titulares</h3>
        <p>A Octopus Group garante aos titulares o pleno exercício dos direitos previstos na LGPD, incluindo:</p>
        <p className="mt-2">• Confirmação da existência de tratamento;</p>
        <p className="mt-1">• Acesso facilitado aos dados;</p>
        <p className="mt-1">• Correção de informações incompletas, inexatas ou desatualizadas;</p>
        <p className="mt-1">• Anonimização, bloqueio ou eliminação de dados excessivos ou tratados em desconformidade;</p>
        <p className="mt-1">• Portabilidade dos dados a outro fornecedor de serviço ou produto;</p>
        <p className="mt-1">• Eliminação de dados tratados com base no consentimento;</p>
        <p className="mt-1">• Informação sobre o compartilhamento de dados;</p>
        <p className="mt-1">• Informação sobre a possibilidade de negar consentimento e sobre as consequências da negativa;</p>
        <p className="mt-1">• Revogação do consentimento, a qualquer tempo.</p>
        <p className="mt-2">
          📩 Para exercer esses direitos, o titular pode entrar em contato pelo e-mail: lgpd@laib.com.br.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">4. Encarregado de Proteção de Dados (DPO)</h3>
        <p>
          A Octopus Group nomeou um Encarregado de Proteção de Dados (Data Protection Officer – DPO), responsável por 
          supervisionar as práticas de conformidade e servir como canal de comunicação com os titulares e com a ANPD.
        </p>
        <p className="mt-2">
          <strong>Contato do DPO:</strong><br />
          Nome: Departamento de Proteção de Dados – Octopus Group<br />
          E-mail: dpo@laib.com.br<br />
          Telefone: (51) 99181-2486
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">5. Segurança da Informação</h3>
        <p>
          Adotamos medidas de segurança de padrão internacional para proteger os dados pessoais, incluindo:
        </p>
        <p className="mt-2">• Criptografia em repouso e em trânsito;</p>
        <p className="mt-1">• Controles de acesso baseados em papéis (RBAC);</p>
        <p className="mt-1">• Autenticação multifator;</p>
        <p className="mt-1">• Monitoramento contínuo de ameaças;</p>
        <p className="mt-1">• Planos de resposta a incidentes;</p>
        <p className="mt-1">• Testes de segurança e auditorias periódicas;</p>
        <p className="mt-1">• Programas de conscientização e treinamento em proteção de dados para colaboradores.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">6. Relatório de Impacto à Proteção de Dados Pessoais (RIPD)</h3>
        <p>
          Em conformidade com a LGPD, a Octopus Group realiza RIPDs para operações de tratamento que possam gerar riscos 
          relevantes aos direitos dos titulares.
        </p>
        <p className="mt-2">Esses relatórios documentam:</p>
        <p className="mt-1">• Finalidades e bases legais do tratamento;</p>
        <p className="mt-1">• Riscos identificados;</p>
        <p className="mt-1">• Medidas técnicas e administrativas adotadas para mitigação;</p>
        <p className="mt-1">• Salvaguardas de segurança e governança.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">7. Transferências Internacionais de Dados</h3>
        <p>
          Em caso de transferência internacional de dados pessoais, asseguramos que:
        </p>
        <p className="mt-2">• O país de destino ofereça grau de proteção adequado reconhecido pela ANPD; ou</p>
        <p className="mt-1">• Sejam implementadas salvaguardas contratuais (cláusulas padrão, regras corporativas vinculantes, certificações ou códigos de conduta aprovados).</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">8. Notificação de Incidentes</h3>
        <p>
          Caso ocorra incidente de segurança que possa acarretar risco ou dano relevante, a Octopus Group compromete-se a:
        </p>
        <p className="mt-2">• Notificar a Autoridade Nacional de Proteção de Dados (ANPD) em prazo razoável;</p>
        <p className="mt-1">• Comunicar os titulares afetados, sempre que necessário;</p>
        <p className="mt-1">• Adotar medidas técnicas e administrativas para mitigar impactos;</p>
        <p className="mt-1">• Implementar ações corretivas para evitar recorrência.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">9. Treinamento e Governança</h3>
        <p>
          Todos os colaboradores da Octopus Group com acesso a dados pessoais recebem treinamento regular em privacidade 
          e segurança da informação.
        </p>
        <p className="mt-2">
          Além disso, mantemos políticas internas de governança alinhadas às diretrizes da LGPD e às melhores práticas internacionais.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">10. Revisão e Atualização</h3>
        <p>
          Esta Declaração de Conformidade com a LGPD é revisada periodicamente e sempre que houver alterações significativas 
          na legislação, na Plataforma ou em nossas práticas de tratamento de dados.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">11. Contato e Reclamações</h3>
        <p>
          Em caso de dúvidas, solicitações ou reclamações sobre nosso tratamento de dados pessoais, entre em contato com 
          nosso DPO (dados acima).
        </p>
        <p className="mt-2">
          Se a resposta não for satisfatória, o titular tem o direito de apresentar reclamação diretamente à Autoridade 
          Nacional de Proteção de Dados (ANPD).
        </p>
      </section>
    </div>
  );
};

export default LGPDComplianceContent;